(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[605],{

/***/ 4637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-we-compare",
      function () {
        return __webpack_require__(222);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3976);
/* harmony import */ var _components_ButtonLink_ButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2591);
/* harmony import */ var _components_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7432);
/* harmony import */ var _components_Table_CompareTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6259);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7435);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3538);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_section_module_css__WEBPACK_IMPORTED_MODULE_6__);







var HowWeCompare = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "peoplecollaborating.png",
                                                alt: "People working on laptop together"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                    className: "text-3xl tracking-tight md:text-5xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block text-blue-dark",
                                                            children: "We created the health insurance"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block text-globeGreen",
                                                            children: "that we’ve always wanted to have."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "max-w-lg mt-6 text-xl text-grey sm:max-w-3xl",
                                                    children: "Better health insurance for everyone by putting people first."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ButtonLink_ButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    uri: "/contact-us",
                                                    children: "Get a Quote"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:grid lg:grid-cols-2 lg:gap-zf8 lg:items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "lg:col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: "text-4xl tracking-tight font-extralight",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "block text-blue-dark",
                                                        children: "Tech-forward. People first."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "block text-blue",
                                                        children: "The Evry Difference."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "max-w-lg mt-6 text-lg text-grey sm:max-w-3xl",
                                                children: "We've developed one of the best tech stack in the industry. We automated everything possible to improve responsiveness and efficiency. We directly contracted our own medical network of great local doctors. And we encourage digital medicine and virtual care. Less overhead = more savings for everyone, and better coverage."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "lg:col-span-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex items-center justify-center h-full",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                                className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_6___default().sectionImageRight)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "object-cover w-full h-full mt-4 md:mt-0",
                                                    src: "friends-looking-at-sunset.png",
                                                    alt: "friends looking at sunset"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "py-16",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Table_CompareTable__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HowWeCompare);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2146,7435,5217,5841,2533,9774,2888,179], function() { return __webpack_exec__(4637); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);